
import VideoClip from '../../assets/videos/clip2.mp4';
import './main-section.scss'

export default function MainSection() {
    return (
        <div className="sv-main-section">
            <video autoPlay muted loop className="sv-main-section-bg-video">
                <source src={VideoClip} type="video/mp4" />
            </video>
            <div className="sv-main-section-grid">
                <div className="sv-main-section-grid-themeOverlay">
                    <div className="sv-main-section-grid-themeOverlay-title">
                        Sense Vibrations
                    </div>
                    <div className="sv-main-section-grid-themeOverlay-subtitle">
                        <p>
                            A holistic approach to spiritual guidance by sensing the vibrations we all uniquely create.
                        </p>
                        <br />
                        <p>
                            By harnessing mediums such as Tarot Cards to help with clarity, Numerology for self-discovery, Sound Therapy for balance and Crystals for healing.
                         </p>
                    </div>
                    {/* <div className="sv-main-section-grid-themeOverlay-button" role="button">
                        let's sense
                    </div> */}
                </div>
                <div className="sv-main-section-grid-darkOverlay" />
                <div className="sv-main-section-grid-content">
                </div>
            </div>
        </div>
    );
}

